const firebaseConfig = {
  apiKey: "AIzaSyAxhzX0H4GDjshItWihGDVcLnEnisLmSeE",
  authDomain: "assignment-11-e1311.firebaseapp.com",
  projectId: "assignment-11-e1311",
  storageBucket: "assignment-11-e1311.appspot.com",
  messagingSenderId: "428025799948",
  appId: "1:428025799948:web:d3edef194f8705bda9d529"
};

export default firebaseConfig;